var _circle, _circle2, _circle3, _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIconAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5771,
    cy: 23.0776,
    r: 22.8867,
    fill: "#002eff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5768,
    cy: 23.0778,
    r: 10.5237,
    stroke: "white",
    strokeWidth: 1.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5771,
    cy: 19.3896,
    r: 3.08852,
    transform: "rotate(-180 23.5771 19.3896)",
    stroke: "white",
    strokeWidth: 1.2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_94_606",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3415 25.1221C17.9438 25.9767 15.9842 27.754 14.8901 30.0267C16.9287 32.5716 20.0624 34.2014 23.5768 34.2014C27.0914 34.2014 30.2253 32.5715 32.2638 30.0263C31.1696 27.7538 29.21 25.9765 26.8124 25.1221C26.1855 26.264 24.9716 27.0381 23.5769 27.0381C22.1823 27.0381 20.9684 26.264 20.3415 25.1221Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8901 30.0267L13.8089 29.5061L13.4811 30.187L13.9535 30.7769L14.8901 30.0267ZM20.3415 25.1221L21.3934 24.5446L20.9014 23.6486L19.9386 23.9918L20.3415 25.1221ZM32.2638 30.0263L33.2004 30.7765L33.6728 30.1866L33.345 29.5057L32.2638 30.0263ZM26.8124 25.1221L27.2153 23.9917L26.2524 23.6486L25.7605 24.5446L26.8124 25.1221ZM15.9714 30.5472C16.9295 28.5569 18.6467 27.0001 20.7443 26.2525L19.9386 23.9918C17.241 24.9532 15.0389 26.9511 13.8089 29.5061L15.9714 30.5472ZM23.5768 33.0014C20.4421 33.0014 17.6473 31.5494 15.8267 29.2765L13.9535 30.7769C16.21 33.5939 19.6827 35.4014 23.5768 35.4014V33.0014ZM31.3271 29.2761C29.5066 31.5492 26.7117 33.0014 23.5768 33.0014V35.4014C27.4711 35.4014 30.9439 33.5938 33.2004 30.7765L31.3271 29.2761ZM26.4096 26.2524C28.5072 27 30.2244 28.5567 31.1826 30.5469L33.345 29.5057C32.1149 26.9509 29.9128 24.9531 27.2153 23.9917L26.4096 26.2524ZM25.7605 24.5446C25.3359 25.3181 24.5163 25.8381 23.5769 25.8381V28.2381C25.427 28.2381 27.0351 27.2099 27.8643 25.6996L25.7605 24.5446ZM23.5769 25.8381C22.6376 25.8381 21.818 25.3181 21.3934 24.5446L19.2896 25.6996C20.1188 27.21 21.7269 28.2381 23.5769 28.2381V25.8381Z",
    fill: "white",
    mask: "url(#path-4-inside-1_94_606)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconAlt);
export default __webpack_public_path__ + "static/media/user_icon_alt.ee99eaad39319654ce89ed36fef08b01.svg";
export { ForwardRef as ReactComponent };